import { createActionGroup, props } from '@ngrx/store';

export const localStorageActions = createActionGroup({
  source: 'LocalStorage',
  events: {
    'Set Local Storage Item': props<{ key: string; value: unknown }>(),
    'Remove Local Storage Item': props<{ key: string }>(),
  },
});
